import { useQuery } from '@tanstack/react-query'
import { tempAccessApi, indexTempAccessByDevice } from '../services/tempAccessApi'
import { getTenantId } from '../config/tenant'

export const TEMP_ACCESS_QUERY_KEY = 'tempAccesses'

/** Concessões abertas do tenant indexadas por device (ícone/linha vermelha na lista). */
export const useTempAccessesByDevice = () => {
  const tenantId = getTenantId()
  return useQuery({
    queryKey: [TEMP_ACCESS_QUERY_KEY, tenantId],
    queryFn: async () => indexTempAccessByDevice(await tempAccessApi.listOpen(tenantId)),
    enabled: !!tenantId,
    refetchInterval: () => (typeof document !== 'undefined' && document.hidden ? false : 20000),
    refetchIntervalInBackground: false,
  })
}
